import React, { useState } from "react";
import { Modal, Carousel } from "react-bootstrap";
import "./css/Card.css";

const Card = ({ info }) => {
  const [popup, setPopup] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <div class="d-flex justify-content-center mb-3 car-card">
        <div class="col-md-12 col-xl-10">
          <div
            class="card shadow-0 border rounded-3"
            style={{ transition: "all 0.3s ease-in-out" }}
          >
            <div
              class="card-body"
              style={{ transition: "all 0.3s ease-in-out" }}
            >
              <div class="row">
                <div class="col-md-12 col-lg-3 col-xl-3 mb-4 mb-lg-0">
                  <div class="bg-image hover-zoom ripple rounded ripple-surface">
                    <Carousel
                      interval={null}
                      onSlide={(index) => setActiveIndex(index)}
                    >
                      {info?.img.map((image, index) => (
                        <Carousel.Item key={index}>
                          <img
                            src={image}
                            className="w-100 img"
                            loading="lazy"
                            alt="car"
                          />
                        </Carousel.Item>
                      ))}
                    </Carousel>

                    {/* <div className="img-container">
                    <img src={info?.img[0]} className="w-100 img" />
                    <div className="dots">
                      {info?.img?.map((val, index) => {
                        if (index < 3) {
                          return <span class="text-primary"> •</span>;
                        }
                      })}
                    </div>
                  </div> */}
                    <a href="#!">
                      <div class="hover-overlay">
                        <div
                          class="mask"
                          style={{
                            backgroundColor: "rgba(253, 253, 253, 0.15",
                          }}
                        ></div>
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-6 col-xl-6 car-body"
                  onClick={() => {
                    setPopup(true);
                  }}
                >
                  <h5 className="car-name">{info?.title}</h5>
                  <div class="mb-1 text-muted small">
                    <span className="engine-info">{info?.transmission}</span>
                    <span class="text-primary"> • </span>
                    <span className="engine-info">{info?.fuel}</span>
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-3 col-xl-3 border-sm-start-none border-start car-body"
                  onClick={() => {
                    setPopup(true);
                  }}
                >
                  <div class="d-flex flex-column  mb-1">
                    {info?.price?.day && (
                      <h4 class="mb-1 me-1 d-flex align-items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-currency-rupee"
                          viewBox="0 0 16 16"
                        >
                          <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4v1.06Z" />
                        </svg>{" "}
                        {info?.price?.day} / D
                      </h4>
                    )}
                    {info?.price?.month && (
                      <h4 class="mb-1 me-1 d-flex align-items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-currency-rupee"
                          viewBox="0 0 16 16"
                        >
                          <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4v1.06Z" />
                        </svg>{" "}
                        {info?.price?.month} / M
                      </h4>
                    )}
                    {info?.price?.wd && (
                      <p class="mb-1 me-1 d-flex align-items-center wedding-rent">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          fill="currentColor"
                          color="#0d6efd"
                          class="bi bi-currency-rupee"
                          viewBox="0 0 16 16"
                        >
                          <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4v1.06Z" />
                        </svg>{" "}
                        {info?.price?.wd} - Wedding Rent
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {popup && (
        <ImageCarousel
          info={info}
          show={popup}
          handleClose={() => setPopup(false)}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
        />
      )}
    </>
  );
};

export default Card;

const Image = ({ image, index }) => {
  const [loading, setLoading] = useState(false);

  return loading ? (
    <div class="d-flex justify-content-center align-items-center carousel-loading">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <img
      src={image}
      className="d-block w-100"
      onLoadStart={() => setLoading(true)}
      onLoad={() => setLoading(false)}
      onError={() => setLoading(false)}
      style={{ display: loading ? "none" : "block" }}
      loading="lazy"
      alt="car"
    />
  );
};

const ImageCarousel = ({
  info,
  show,
  handleClose,
  activeIndex,
  setActiveIndex,
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body style={{ padding: 0, background: "transparent" }}>
        <Carousel
          interval={null}
          style={{
            transition: "all 0.3s ease-in-out",
          }}
          activeIndex={activeIndex}
          onSelect={(index) => setActiveIndex(index)}
        >
          {info?.img?.map((image, index) => (
            <Carousel.Item key={index}>
              <Image image={image} index={index} />
            </Carousel.Item>
          ))}
        </Carousel>
      </Modal.Body>
    </Modal>
  );
};
